import type { FormikHelpers } from 'formik'
import { Form, Formik } from 'formik'
import { useSnackbar } from 'notistack'
import React from 'react'
import type { OptionsDocument } from 'paintscout'
import { useCreateClientMutation } from '@paintscout/api'
import type { DialogProps } from '../components/Dialog'
import Dialog, { DialogActions, DialogContent, DialogTitle } from '../components/Dialog'
import Button from '../components/Button'
import NewClientForm from '../forms/NewClientForm'

export interface NewClientDialogProps extends DialogProps {
  onConfirm: (clientId: string) => any
}
export default function NewClientDialog({ onConfirm, ...props }: NewClientDialogProps) {
  const { enqueueSnackbar } = useSnackbar()

  const [createClient] = useCreateClientMutation()

  const template = 'trial'
  const product = 'ps'

  const initialValues = {
    options: {
      companyName: { value: '' },
      companyAddress: { value: '' },
      companyPhone: { value: '' },
      companyCity: { value: '' },
      companyProv: { value: '' },
      companyPostal: { value: '' }
    }
  } as OptionsDocument

  async function handleSubmit(values: OptionsDocument, actions: FormikHelpers<OptionsDocument>) {
    actions.setStatus({ error: null })

    try {
      const { data } = await createClient({
        variables: {
          input: {
            options: values,
            meta: {
              signupMethod: 'admin',
              product
            },
            template
          }
        },
        refetchQueries: ['searchClients']
      })

      onConfirm(data.createClient._id)
      enqueueSnackbar('Client Created', { variant: 'success' })
    } catch (e) {
      console.error(e)
      enqueueSnackbar('Unable to create client', { variant: 'error' })
    }
    actions.setSubmitting(false)
  }

  return (
    <Dialog {...props}>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ isSubmitting }) => (
          <Form>
            <DialogTitle loading={isSubmitting}>New Client</DialogTitle>
            <DialogContent>
              <NewClientForm />
            </DialogContent>
            <DialogActions
              leftButton={
                <Button variant="textNoPadding" disabled={isSubmitting} onClick={() => props.onClose(null, null)}>
                  Cancel
                </Button>
              }
            >
              <Button disabled={isSubmitting} type="submit">
                Save
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
